import { render, staticRenderFns } from "./UsersSendInvites.vue?vue&type=template&id=fd196a3a&scoped=true&"
import script from "./UsersSendInvites.vue?vue&type=script&lang=js&"
export * from "./UsersSendInvites.vue?vue&type=script&lang=js&"
import style0 from "./UsersSendInvites.vue?vue&type=style&index=0&id=fd196a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd196a3a",
  null
  
)

export default component.exports